import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Container} from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  card: {
    backgroundColor: theme.palette.info.main
  },
  content: {
    color:"white",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2)
  },
  container: {
    margin: theme.spacing(0)
  }
}));

const ApaItuPCAB = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Container className={classes.container}>
      <Card className={classes.card}>
      <CardActions disableSpacing>
        <Alert variant="filled" severity="info">
          <AlertTitle>{"Apa itu PCAB ?"}</AlertTitle>
            <Typography variant="body2">
              {
                "Berikut pengertian mengenai PCAB"
              }
            </Typography>
        </Alert>
        <IconButton
        className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
        })}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
        >
        <ExpandMoreIcon />
        </IconButton>
      </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Container>
            <CardContent className={classes.content}>
            <Typography variant="body1" gutterBottom>
            Penerimaan Calon Anggota Baru (PCAB) KSR PMI Unit UNJ adalah rangkaian kegiatan untuk menerima Calon Anggota Baru yang dilakukan setiap tahunnya. PCAB bertujuan untuk menambah sumber daya manusia dari KSR PMI Unit UNJ itu sendiri yang sesuai dengan prinsip dasar gerakan internasional palang merah dan bulan sabit merah
            </Typography>
            </CardContent>
          </Container>
        </Collapse>
        </Card>
    </Container>
  );
}

export default ApaItuPCAB